var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subpage"},[_c('h1',[_vm._v(" Strona nie istnieje ")]),_c('div',{staticClass:"back back--form"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Strona główna")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }